export default "__VITE_PUBLIC_ASSET__4ce0a9bc__"